/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { LocalStorageService } from './@core/utils/local-storage.service';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private router: Router,
    private lss: LocalStorageService
  ) {
  }

  ngOnInit() {
    this.analytics.trackPageViews();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd && this.permiteString(event.urlAfterRedirects) ),
    ).subscribe({
      next: (url: NavigationEnd) => {
        this.lss.setlastUrl(url.urlAfterRedirects);
      }
    });
  }

 private permiteString(str) {
  if (typeof str !== 'string') return false;
  const prohibidos = ['login', 'logout', 'signup'];
  for (const p of prohibidos) {
    if (str.includes(p)) return false;
  }
  return true;
}
}
